import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    padding: '8px 18px',
    borderRadius: '999px',
    border: '2px solid',
    borderColor: ({ isActive }) => (isActive ? '#e6616a' : '#444'),
    backgroundColor: '#1f1f1f',
    color: '#ffffff',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#e6616a',
    },
  },
}));

const ModernButton = ({ onClick, text, isActive }) => {
  const classes = useStyles({ isActive });

  return (
    <button type="button" onClick={onClick} className={classes.button}>
      {text}
    </button>
  );
};

export default ModernButton;
